import {createApp} from 'vue'
import App from './App.vue'
import VOtpInput from "vue3-otp-input";
import axios from 'axios'
import VueAxios from 'vue-axios'

const app = createApp(App)
app.use(VueAxios, axios)
app.component('v-otp-input', VOtpInput)
app.mount('#app')